<template>
  <div class="d-flex h-100 p-3 mx-auto flex-column coverContainer">
    <main class="inner cover">
      <div class="container-fluid h-100">
        <div class="row h-100 align-items-center">
          <div class="col-auto">
            <LoginComponent v-if="state === 'idle'" :data="data" :for-dev="forDev" :with-sesion="withSesion" :mode="mode"/>
          </div>
        </div>
      </div>
    </main>
    <Loading v-if="state === 'load'"/>
  </div>
</template>

<script>
import LoginComponent from '../components/LoginComponent'
import Loading from '../components/elements/Loader'
import hexRgb from 'hex-rgb'
export default {
  name: 'Login',
  components: {
    LoginComponent,
    Loading
  },
  data () {
    return {
      state: 'load',
      data: null,
      identifier: '',
      operation: 'normal',
      mode: 'normal',
      withSesion: true,
      forDev: false
    }
  },
  methods: {
    chargeInfo () {
      this.state = 'load'
      this.$oauthcore.api.Sesiones.getKeyByPublic(this.identifier).then((rta) => {
        this.data = rta.result
        // this.data.devApp.background = ''
        // convertimos el color en rgb
        const color = hexRgb(this.data.devApp.color)
        this.data.devApp.color = `${color.red}, ${color.green}, ${color.blue}`
        this.state = 'idle'
        document.title = `Iniciar sesion en ${this.data.devApp.nombre} - Sistema de Autenticacion de Medisoft Colombia`
        this.chargeBackgroundImage()
        this.changeColorEnphasis()
      }).catch((err) => {
        this.state = 'idle'
        console.log(err)
      })
    },
    chargeBackgroundImage () {
      document.getElementById('bodyel')
        .setAttribute('style', `padding: 5px; background-size: 'cover'; background-image: ${(this.state === 'idle' ? `linear-gradient(rgba(${this.data.devApp.color}, 0.8), rgba(${this.data.devApp.color}, 0.8)), url(data:${this.data.devApp.backgroundExt};base64,${this.data.devApp.background})!important` : '')};`)
    },
    changeColorEnphasis () {
      const openClass = String.fromCharCode(123)
      const closeClass = String.fromCharCode(125)
      var style = document.createElement('style')
      style.type = 'text/css'
      style.innerHTML = `
        .btn-primary ${openClass}
          background-color: rgb(${this.data.devApp.color})!important;
          border-color: rgb(${this.data.devApp.color})!important;
        ${closeClass}
        .btn-primary:hover ${openClass}
          background-color: rgba(${this.data.devApp.color}, 0.9)!important;
          border-color: rgba(${this.data.devApp.color}, 0.9)!important;
        ${closeClass}
        .btn-link ${openClass}
          color: rgb(${this.data.devApp.color})!important;
        ${closeClass}
        .btn-link:hover ${openClass}
          color: rgba(${this.data.devApp.color}, 0.9)!important;
        ${closeClass} `
      document.getElementsByTagName('head')[0].appendChild(style)
    }
  },
  mounted () {
    // Obtencion de los parametros del uri
    // Identificador del software
    if (this.$route.query.identifier) this.identifier = this.$route.query.identifier
    else this.identifier = ''
    // cargamos las opciones de verificacion o ejecucion
    if (this.$route.query.withsesion) this.withSesion = (this.$route.query.withsesion === 'true')
    else this.withSesion = false
    // modo de ejecucion si es popup o normal en navegador
    if (this.$route.query.mode) this.mode = this.$route.query.mode // normal - popup
    else this.mode = 'normal'
    // define si la verficacion es de perfil de desarrollador
    if (this.$route.query.fordev) this.forDev = (this.$route.query.fordev === 'true')
    else this.forDev = false
    // Carga de informacion
    this.chargeInfo()
  }
}
</script>

<style lang="scss">
  html,
  body {
    height: 100%;
  }
  body {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-pack: center;
    -webkit-box-pack: center;
    justify-content: center;
  }
  .coverContainer {
    width: 100%;
  }
  .cover {
    padding: 0 1.5rem;
    height: 100%;
  }
</style>
